import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  href?: string;
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary';
}
const CHECKOUT_URL = 'https://noveliahub.com/cart/51019183030308:1';
export function CTAButton({
  href = CHECKOUT_URL,
  children,
  className = '',
  variant = 'primary'
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center gap-2 px-8 py-4 text-lg font-bold rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 w-full sm:w-auto text-center';
  const variants = {
    primary: 'bg-brand-orange text-white hover:bg-brand-orangeHover',
    secondary: 'bg-brand-green text-white hover:bg-brand-greenHover'
  };
  return <motion.a href={href} className={`${baseStyles} ${variants[variant]} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-43">
      {children}
      <ArrowRight className="w-5 h-5" data-id="element-44" />
    </motion.a>;
}